import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_SETTINGS_SCHEMA = Object.freeze({});
const RECORD = generateSchema(TRACKING_SETTINGS_SCHEMA);
const KEYS: any = generateKeys(TRACKING_SETTINGS_SCHEMA);

export class SettingsTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.settings;
  }

  get properties() {
    return this.toJS();
  }
}
